import { ChangeDetectionStrategy, Component, Input, OnChanges, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { DateTimeService } from '../../../services/date-time.service';
import { IReadView} from './../../../interfaces/schema.interface';
import { SchemaService } from '../../../services/schema.service';
import { DateFormat } from '../../../interfaces/base-core-services.interface';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cargoes-schema-readview',
  templateUrl: './schema-readview.component.html',
  styleUrls: ['./schema-readview.component.less']
})
export class SchemaReadviewComponent implements OnChanges{

  columnCounter: number;
  @Input() data: any = [];
  @Input() rdmClient: any;
  @Output() onLink  = new EventEmitter<any>();
  @Input() profileId: any;
  constructor(public dataTimeService: DateTimeService,
    private schemaService: SchemaService) {
    this.columnCounter = 1;
  }
  

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.columnCounter = 1;
  }

  getClass():any{
    if(this.columnCounter === 1 || this.columnCounter === 2){
      this.columnCounter++;
      return 'grey-bg';
    }else if(this.columnCounter === 3){
      this.columnCounter++;
      return 'white-bg';
    }else {
      this.columnCounter = 1;
      return 'white-bg';
    }
   
  }

  onLinkClick(keyVal: any): void {
    let profileId =  this.profileId ? { key: 'profileId', text: this.profileId } : null;
    this.onLink.next(profileId ? profileId : keyVal);
  }

  hasDate(value: any): string {
    /* format if value contains date  */
    if (isNaN(value) && !isNaN(Date.parse(value))) return this.dataTimeService.getDateFormat(value, DateFormat.DD_MM_YYYY);
    else return value;
  }

  getStatusLabel(code: string): string {
    if (!this.rdmClient || !code) return code;
    let data = [...this.rdmClient.getRefValues('kc-profile-all-status'), ...this.rdmClient.getRefValues('kc-risk-register-all-status')]
    let statusItem = data?.find((i: any) => i?.code?.toLowerCase() === code?.toLowerCase());
    return (statusItem?.label || code).split('_').join(' ');
  }

  getOutcomeLabel(code?:string) {
     if (!this.rdmClient || !code) return code;
    let data = [...this.rdmClient.getRefValues('kc-profile-approved-recommended-outcome'), ...this.rdmClient.getRefValues('kc-profile-rejected-recommended-outcome')]
    let outcome = data?.find((i: any) => i?.code?.toLowerCase() === code?.toLowerCase());
    return outcome?.label || code;
  }

  getStatusColor(statusCode: string): string {
    if (!statusCode) return '#000000';
    
    const status = statusCode.toLowerCase();
    
    if (status.includes('inactive') || status.includes('in-active') || status.includes('in_active') || status.includes('reject') || status.includes('rejected') || status.includes('cancel') || status.includes('cancelled') || status.includes('expired') || status.includes('suspend')) {
      return '#ff4d4f';
    } else if (status.includes('approve') || status.includes('active') || status.includes('approved')) {
      return '#52c41a';
    } else if (status.includes('pending') || status.includes('review') || status.includes('draft') || status.includes('sandboxing') || status.includes('re-sandboxing')) {
      return '#faad14';
    }
    
    return '#000000';
  }
  
}
